import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-geofence-info-box',
  templateUrl: './geofence-info-box.component.html',
  styleUrls: ['./geofence-info-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, TranslateModule],
})
export class GeofenceInfoBoxComponent {
  isGeofenceSet = input<boolean>();
}
